export const REMINDERS_ACTION = 'Reminders action';
export const REMINDERS_REDIRECT_FROM_SMS = 'redirect from sms';
export const REMINDERS_REDIRECT_FROM_LAST_SMS = 'redirect from last sms';
export const REMINDERS_REDIRECT_FROM_WEB_PUSH = 'redirect from web push';
export const REMINDERS_REDIRECT_FROM_LAST_WEB_PUSH = 'redirect from last web push';
export const REMINDERS_SET_REMINDER = 'set reminder';
export const REMINDERS_UNSET_REMINDER = 'unset reminder';
export const REMINDERS_MARK_DONE = 'mark as done';
export const REMINDERS_MARK_SKIP = 'mark as skip';
export const REMINDERS_VIEWED_FIRST_CARD = 'viewed first card';
export const REMINDERS_SET_LAST_CHECKUP_TIME = 'reminder set last checkup time';
export const REMINDERS_SET_NOT_RELEVANT = 'reminder set not relevant';
export const REMINDERS_MARK_REMINDER = 'reminder mark reminder';
export const REMINDERS_CLICK_CHECKBOX = 'reminder click checkbox';
